const es_ES = {

//components
    "ShangeChuanYanZhengTuPian": "Subir imagen de verificación",
    "ChuanHaoYanZheng": "Verificar IMEI",
    "YanZhengChuanHao": "Verificar IMEI",
    "Ci": "Tiempos",
    "DingDanMan": "Orden completa",
    "YuanZeng": "Regalo S/",
    "SCFJ_ZD4Z_DZBCG": "Cargue archivos adjuntos, hasta 4 fotos, no más de 3M",
//ChatRoom

    "ZBZCBQFH": "Los emoji no son compatibles en este momento",
    "FaSongLianJie": "Enviar enlace",
    "YiChangXiaoXi": "Mensaje excepción",
    "QingShuRu": "Agregar nota",
    "FaSong": "Enviar",


//DateSelector

    "DQSJXYKSSJ": "La hora actual es menor que la hora de inicio",
    "DQSJCGJSSJ": "El tiempo actual excede el tiempo final",
    "QuXiao": "Cancelar",
    "NianYueRi": "Fecha",
    "ShiFen": "Hora",
    "QueDing": "Confirmar",
    "Nian": "Año",
    "Yue": "Mes",
    "Ri": "Día",
    "Shi": "H",
    "Fen": "M",
    "Miao": "S",


//goods-list-card

    "Qi": "Desde ",


//goods-promotion

    "1GeCuXiao": "{num} promoción",
    "ChaKanZengPin": "Regalo",
    "JHDJSHS_1T": "Fecha Envío: {d} - {h} : {m} : {s}",
    "YHGZ_ZPBKD": "Reglas: solo 1 regalo por pedido",
    "YHGZ_AZZGM": "Reglas: Disfruta de descuentos según la cantidad de compra final",
    "GuanBi": "Cerrar",
    "Man1Song1": 'Obtén {mai} por {song}',

//group-filtrate

    "QuanBu": "Todos",
    "ZWXGSJ": "Sin datos",
    "ZuiDiJia": "Desde",
    "ZuiGaoJia": "Hasta",
    "LeiXing": "Categorías",
    "PinPai": "Marca",
    "BiaoQian": "Etiquetas",
    "JiaGeQuJian": "Precio",
    "SPMC_GG_BH_": "Busca productos",
    "ZuHeShaiXuan": "Flitros",
    "ChongZhi_CanShu": "Restablecer",


//image-upload

    "ZDKSC1ZTP": "Sube hasta 1 foto",
    "ZYXSCTP": "Solo sube fotos",
    "SCTPDXBYXC": "El tamaño de carga de la imagen no puede exceder los 5M",
    "QBYCFSCTP_": "No suba imágenes repetidamente ni asegúrese de que el nombre de la imagen sea único.",
    "ShangChuanChengGong": "Subido correctamente",
    "ZDKSC1Z": "Sube hasta 1",


//keyboard

    "CCSLZDXZ": "Excedió el cantidad máximo",
    "QiDingLiang": "MOQ",
    "ShouQi": "Guardar",
    "ShanChu": "Eliminar",


//MultiPicker

    "FanHui": "Volver a",


//order-cart

    "Dai": "Generación",
    "YiQuXiao": "Cancelado",
    "ZengPin": "Gift",
    "1Zhong": "{num} items",
    "1Jian": "{num} pieza",
    "HeJi": "Monto Total",
    "DaiFu": "Por pagar",


//order-promotion

    "_DDM1YZ1J_": "[Gratis {target} para pedidos superiores a {name}{number} soles]",
    "_DDM1YLJ1Y_": "[Reduzca {m} soles cuando ordene más de {n} soles]",
    "_DDM1YLX1Z_": "[Disfrute de {m}% de descuento en pedidos superiores a {n} soles]",
    "DingDanCuXiao": "Promoción de pedidos",


//page-ad

    "DLCKJG": "Inicia sesión ver precios",


//page-floating

    "DianPuZhuYe": "Inicio de tienda",
    "GouWuChe": "Carrito",
    "ZaiXianKeFu": "Servicio online",
    "GeRenZhongXin": "Centro personal",
    "LianXiDianHua": "Teléfono contacto",
    "FanHuiDingBu": "Volver arriba",


//page-null

    "ZBDYML": "Página no encontrada",
    "KNWZCW_HZY": "La URL puede ser incorrecta o la página puede ser eliminada",
    "FanHuiShangJi": "Volver a superior",
    "FanHuiShouYe": "De vuelta a casa",


//product-edit

    "SPQDBNWK": "La lista de productos no puede estar vacía.",
    "WoZhiDaoLe": "Yo se",
    "SFQRSCSP": "¿Estás seguro de que deseas eliminar el producto?",
    "QueRen": "Confirmar",
    "ZYXSRSZBQB": "Solo se permiten números y no más de 2 decimales",
    "ShangPinDanJia": "Precio unitario",
    "YSPYJ": "Precio original",
    "QSRZDJG": "Ingrese el precio especificado",
    "ShuLiang": "Cantidad",
    "DanWei": "Unidad",
    "DanJia": "Precio",
    "BeiZhu": "Nota",
    "YiChuShangPin": "Eliminar",
    "XiuGai": "Modificar",


//yunshl

    "TPSLCCYXSZ": "¡El número de imágenes supera el valor permitido!",
    "WJBDDY5M_QC": "El archivo no debe ser mayor de 5 m, seleccione nuevamente",
    "TPSCWC": "Carga de imagen completada",


//utils
//BusinessFilter
    "_DGSLM1Z1_": "[Cantidad de pedido completa  {target} Regalo {provide}]",
    "_M1JLXMJ1Y_": "[completo {target} Disfruta cada {cut_money_} SOL]",
    "_DHJJZ1Y_": "[El precio del pedido baja {cuted_price_} SOL]",
    "_M1JLXMJ1Z_": "[completo {target} Disfruta cada {cut_percent_}]",
    "_YDHJD1Z_": "[de descuento sobre el precio del pedido original {cuted_percent_}]",
    "YuJiKaiShiFaHuo": "Tiempo estimado de entrega {date}",

    "YuJi": "Esperado",
    "MMYDDR": "MM - DD",
    "KaiShiFaHuo": "Comience a enviar",
    "_M1LXM1Y_": "[Cada 1 soles por 1 unidades]",
    "_M1LXM1Z_": "[Disfrute de cada 1% de descuento por cada 1 compra]",
    "DaiQueRen": "Por confirmar",
    "DaiFaHuo": "Por enviar",
    "DaiShouHuo": "Por recibir",
    "YiWanCheng": "Completado",
    "DaiFuKuan": "Por pagar",
    "YiFuKuan": "Pagado",
    "YiZuoFei": "Inválido",
    "DaiShenHe": "Por verificar",
    "DaiHeXiao": "Cancelación pendiente",
    "YiHeXiao": "Dado de baja",
    "XianXiaZhiFu": "Depósito o Transferencia",
    "ZhiNengDaoZhangShiBie": "线下汇款(智能到账识别)",
    "WeiXinZhiFu": "WeChat pago",
    "ZFBZF": "Pago Alipay",
    "YuEZhiFu": "Pago de saldo",
    "HuoDaoFuKuan": "Contra reembolso",
    "DaiTuiHuo": "Para ser devuelto",
    "DaiTuiKuan": "Por reembolsar",
    "ChuangJianDingDan": "Crear orden",
    "BianJiDingDan": "Editar orden",
    "TiJiaoDingDan": "Enviar pedido",
    "DingDanShenHe": "Revisión pedido",
    "CaiWuShenHe": "Revisión financiera",
    "BoHui": "Desestimar",
    "TianJiaShouKuan": "Agregar pago",
    "ZaiXianZhiFu": "Pagar Online",
    "ShouKuanShenHe": "Revisión recibo",
    "ShouKuanZuoFei": "Recibo inválido",
    "ChuKu": "Saliente",
    "ChuKuShenHe": "Auditoría saliente",
    "FaHuo": "Envío",
    "TianJiaWuLiu": "Añadir logística",
    "XiuGaiWuLiu": "Modificar logística",
    "ChuKuZuoFei": "Sin stock",
    "ShouHuo": "Recibo",
    "DingDanHeZhun": "Aprobación pedido",
    "QuXiaoDingDan": "Canceler pedido",
    "CJTHD": "Crear devolución",
    "DaYin": "Imprimir",
    "DaoChu": "Exportar",
    "DingDanWanCheng": "Pedido finalización",
    "QiangZhiWanCheng": "Terminación forzada",
    "DingDanZuoFei": "Orden nula",
    "MaiZeng": "Con Regalo",
    "ZhiJiang": "Bajo precio",
    "DaZhe": "Descuento",
    "YuShou": "Preventa",
    "DingDanManZeng": "Pedido completo gratuito",
    "DingDanManJian": "Reducción de orden completa",
    "DingDanManZhe": "Orden completa",
    "XinRenQuan": "Cupón de recién llegado",
    "ManJianQuan": "Cupón",
    "ShangPinQuan": "Certificado de mercancia",
    "DaiJieSuan": "Acuerdo pendiente",
    "YiJieSuan": "Resuelto",
    "QuanBuShangPin": "Todos productos",
    "TuiJianShangPin": "Productos recomendados",
    "XinPin": "Nuevo producto",
    "ReXiaoShangPin": "Productos Hot",
    "ChangYongShangPin": "Común",


//BusinessUtil

    "DaiShouKuan": "Por recibir",
    "BuFenShouKuan": "Colección parcial",
    "YiShouKuan": "Recibido",
    "BXYFP": "Boleta",
    "ZZSPTFP": "Factura",
    "ZZSZYFP": "Factura con IVA",
    "QiTaFaPiao": "Otras facturas",
    "XianXia": "Offline",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Depósito",
    "XianXiaZhuangZhang": "Transferencia offline",
    "XianShangZhiFu": "Pago online",
    "YCKZF": "Depósito",
    "DaiTiJiao": "Pendiente",
    "KuaiDi": "Expreso",
    "SongHuoShangMen": "Contraentrega",
    "ShangMenZiQu": "Recojo en Tiendas",
    "WuLiuHuoYun": "Logística",
    "QiTa": "Otros",


//check-util

    "QSRBXY6WDM": "Ingrese una contraseña de al menos 6 dígitos",
    "QSRBDY20WDM": "Ingrese una contraseña que no tenga más de 20 dígitos",
    "MMGSCW": "Formato de contraseña incorrecta",


//common-utils

    "SJCW_QLXKF": "Error de datos, póngase en contacto con el servicio al cliente",
    "ZBZCQD": "Iniciar sesión no es compatible en este momento",
    "HuJiao": "Llamar",
    "DLZHBCZ": "La cuenta de inicio de sesión no existe",
    "QLXGLYKT": "Póngase en contacto con el administrador para activar",
    "GQYZHBJY": "La cuenta corporativa está deshabilitada",
    "QLXYSDH": "Por favor contacte a Yunshang para ordenar",
    "GQYZHSYQJS": "El período de prueba de la cuenta empresarial finaliza",
    "GQYZHYGQL": "La cuenta corporativa ha expirado",
    "XYXFCNSY": "Necesita renovación para usar",
    "GQYBCZCZH": "Esta cuenta no existe para esta empresa.",
    "NDDHZHYBQY": "Enterprise 1 ha deshabilitado su cuenta de pedido y no puede iniciar sesión. Por favor contacte al administrador",
    "NYBSQY1DHZ": "Ya no eres socio de Enterprise 1 y no puedes iniciar sesión. Por favor contacte al administrador",
    "NDDPYBTY_B": "Su tienda ha sido deshabilitada y no se puede iniciar sesión. Por favor contacte al administrador",
    "GZHWKTDSZB": "Esta cuenta no tiene la característica especial de iluminación. Por favor contacte al administrador",
    "WXSQYZYGQ": "La verificación de autorización de WeChat ha expirado",
    "WXSQSB": "La autorización de WeChat falló",
    "WXSQSB_CWX": "La autorización de WeChat falló con un mensaje de error",
    "DengLuGuoQi": "Inicio sesión caducado",
    "DLGQ_QCXDL": "Inicio de sesión caducado, vuelva a iniciar sesión",


//data-constant

    "ShangJia": "Estantes",
    "YiXiaJia": "Retirado",
    "YiJinYong": "Discapacitados",
    "YiQiYong": "Habilitado",
    "YiTingYong": "Discapacitados",
    "KeHuZhuCe": "Registro clientes",
    "XinZengDaoRu": "Nueva importación",
    "DDDSH": "Revisión de pedido pendiente",
    "DCWSH": "Revisión financiera pendiente",
    "DaiChuKu": "Para ser enviado",
    "DCK_BF_": "Fuera de stock (parcial)",
    "DFH_BF_": "Para ser enviado (parcial)",
    "DSH_BF_": "Para ser recibido (parcial)",
    "DSK_BF_": "Por recibir (parciales)",
    "WTHSQ": "Sin solicitud de devolución",
    "THDSH": "Devoluciones pendientes de revisión",
    "THCLZ": "Procesamiento de devolución",
    "THYWC": "Devolución completada",
    "DYDHD": "Imprimir formulario de pedido",
    "DYFHD": "Imprimir factura",
    "DCDHD": "Orden de exportación",
    "DCFHDWE_P": "Exportar factura a archivo Excel / PDF",
    "TuiDanZuoFei": "Reembolso nulo",
    "DTHSH": "Revisión de devoluciones pendientes",
    "DaiRuKu": "Para ser almacenado",
    "DRK_BF_": "Para ser almacenado (parcial)",
    "DFK_BF_": "Pago pendiente (parcial)",
    "ChuangJianTuiDan": "Crea un reembolso",
    "BianJiTuiDan": "Editar reembolso",
    "TiJiaoTuiDan": "Enviar un reembolso",
    "TuiHuoShenHe": "Auditoría de devolución",
    "RuKu": "Almacén",
    "RuKuShenHe": "Auditoría entrante",
    "RuKuZuoFei": "Invalidación",
    "TianJiaFuKuan": "Agregar pago",
    "FuKuanZuoFei": "Pago nulo",
    "FuKuanShenHe": "Revisión de pago",
    "TuiDanWanCheng": "Reembolso completado",
    "QiTaChuKu": "Otros salientes",
    "XiaoShouChuKu": "Ventas agotadas",
    "PanKuiChuKu": "Fuera de stock",
    "DiaoBoChuKu": "Transferir fuera",
    "CaiGouTuiHuo": "Compra devuelve",
    "TuiHuoRuKu": "Devoluciones y almacenaje",
    "CaiGouRuKu": "Compra de almacenamiento",
    "QiTaRuKu": "Otro almacenamiento",
    "PanYingRuKu": "Excedente de stock",
    "DiaoBoRuKu": "Traslado al almacén.",
    "CJCGD": "Crear orden de compra",
    "BJCGD": "Editar orden de compra",
    "TJCGD": "Enviar orden de compra",
    "CGDZF": "Orden de compra nula",
    "CGDWC": "Orden de compra completada",
    "CGTHZF": "Devoluciones de compras obsoletas",
    "CGTHWC": "Devoluciones de compra completadas",
    "THDDY": "Impresión de formulario de devolución",
    "THDDC": "Exportar pedido de devolución",
    "CKDDY": "Impresión de pedidos salientes",
    "CKDDC": "Exportación de pedidos salientes",
    "GLDZH": "Cuenta de gestión",
    "DHDZH": "Cuenta de pedido",
    "ShenHeTongGuo": "Aprobado",
    "SHBTG": "Revisión fallida",
    "WuXuFaPiao": "No se requiere factura",
    "DaiKeXiaDan": "Orden en nombre de",
    "ZiZhuXiaDan": "Pedido del cliente",
    "PCShangCheng": "Centro comercial PC",
    "APPShangCheng": "APP mall",
    "TVShangCheng": "Centro comercial de televisión",
    "WeiXinShangCheng": "WeChat Mall",
    "ShouJiShangCheng": "Centro comercial móvil",
    "ADDXSMLTC": "Margen bruto a medida",
    "ADDXSSRTC": "Comisión sobre ingresos por ventas",
    "AKHSSYG": "Por empleado",
    "AnZhiDanRen": "Soltero",
    "ATHJEBLKCT": "Deduzca el monto de la comisión en función del monto devuelto",
    "DDYTHBJXTC": "No hay devoluciones para pedidos",
    "DaiDaKuan": "Pago pendiente",
    "WeiKaiShi": "No empezado",
    "JinXingZhong": "En progreso",
    "YiGuoQi": "Caducado",


//Utils.js

    "YouHuo": "En stock",
    "WuHuo": "Fuera de stock",
    "Yi": "Mil millones",
    "QianWan": "Diez millones",
    "BaiWan": "Millones",
    "Wan": "mil diez",
    "Sheng1Tian": "Queda 1 día",
    "Sheng1XiaoShi": "Queda 1 hora",
    "1Miao": "1 segundo",
    "GangGang": "Justo ahora",
    "1FenZhongQian": "Hace 1 minuto",
    "1XiaoShiQian": "Hace 1 hora",
    "1TianQian": "Hace un dia",
    "1GeYueQian": "Hace 1 mes",
    "1NianQian": "Hace 1 año",
    "WeiZhiLeiXing": "Tipo desconocido",


//WechatUtil

    "YYGBCDSP_K": "Hay un buen producto, mira",
    "ZanWeiSheZhi": "No establecido",


//app

    "HQWXSQXX": "Obtenga información de autorización de WeChat",


//flexible

    "JGJYYDMBQ": "La escala se establecerá de acuerdo con las metaetiquetas existentes",


//index

    "NLJZZ": "Loading...",


//cart-bill

    "ShangPinMingXi": "Detalles producto",
    "ShangPinLeiBie": "Categoría producto",
    "QXZFPNR": "Seleccione el contenido factura",
    "QXZFPLX": "Seleccione un tipo factura",
    "QTXFPTT": "Complete el encabezado factura",
    "FaPiaoTaiTou": "Razón social",
    "NSRSBH": "RUC / DNI",
    "FaPiaoNeiRong": "Contenido de la factura",
    "FaPiaoXinXi": "Factura",
    "KaiJuFaPiao": "Facturación",
    "FaPiaoLeiXing": "Tipo de factura",
    "Han": "Con",
    "WeiHan": "No incluido",
    "Shui": "Impuestos",
    "QSRFPTT": "Por favor ingrese razón social",
    "QSRNSRSBH": "Por favor ingrese RUC / DNI",


//cart-list

    "YiManZu_Man": "Cumplir [lleno",
    "ZaiGou": "Recompra",
    "YMZ_DHJJZ": "Ha quedado satisfecho",
    "JianJiangZhi": "Pedazos abajo",
    "YMZ_YDHJD": "Ha cumplido [precio de pedido original alcanzado",
    "JianMeiJian": "Piezas por pieza",
    "SYTCSLW0_WFJRGWC": "El número de paquetes restantes es 0",
    "QingXuanXeShangPin": "Por favor seleccione un producto!",
    "GSPYXJ": "¡Este producto ya no está disponible!",
    "ZJ2TN": "En los últimos {day} días",
    "QDQCXJSP": "¿Está seguro de que desea borrar el producto?",
    "QingChuChengGong": "Borrado éxito",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Los Combo no se pueden agregar al carrito de compras, cancele los artículos del paquete y luego muévase al carrito de compras.",
    "SPSLBN": "La cantidad producto no puede",
    "TaoCanHan": "El Combo incluye",
    "TaoCan": "Combo",
    "QHDSL": "verifique la cantidad",
    "SPSLBNDY": "El cantidad de productos no puede ser inferior a",
    "XianDingLiang": "Cantidad máxima",
    "YiRuShouCang": "Favoritos",
    "QuanXuan": "Todos",
    "JianZeng": "Regalo",
    "JianLiXiang_Man": "Disfruta",
    "Yuan_": " Soles",
    "Zhe_": "Doblar",
    "KCBZ_WFJRGWC": "Inventario insuficiente para agregar al carrito",
    "XDJEDYDY": "El monto pedido es mayor o igual que",
    "WYXJHYSXDSP": "¡No se han eliminado ni caducado productos!",
    "DYQDL": "MOQ",
    "ZSPG1J": "{count} Productos {number} unidades",
    "WanCheng": "Completa",
    "BianJi": "Editar",
    "You": "Tener",
    "ZSPBFHYQ_W": "Los productos no cumplen con los requisitos y no están marcados, haga clic para ver",
    "SPSLBNGY": "El cantidad de productos no puede ser superior a",
    "JXDJ_CKXYGBFHYQSP": "Continúe haciendo clic para ver el siguiente producto no conforme",
    "XiaDan": "Enviar",
    "JianJiang": "Pieza caída",
    "QRYCSP": "¿Eliminar producto?",
    "QXZXDSP": "Por favor seleccione un pedido",
    "KCBZ_QCXXZ": "Stock insuficiente, ¡elija de nuevo!",
    "KuCun": "Stock",
    "YCKXD": "Soles puede hacer un pedido",
    "QDSCSP": "¿Estás seguro de que quieres recoger mercancías?",
    "ShouCangChengGong": "Éxito de la colección",
    "GYXDL": "Por encima del límite",
    "LiSheng": "salvar",
    "GWCHSKD_QGYGB": "El carrito de compras aún está vacío.",
    "QuGuangGuang": "Ir de compras",
    "QCXJSP": "Productos claros",
    "ZongE": "Total monto",
    "YouHui": "Descuento",
    "YMZ_MYZJ_": "Ha satisfecho [piezas completas de {m} regalo de S/ {n}]",
    "YMZ_MZ": "Ha satisfecho [piezas completas de {m} regalo de S/ {n}]",
    "ZG222YX_M1000": "Vuelva a comprar {currencySymbol} {money} para disfrutar [obtenga {number} por cada {currencySymbol} {target} ]",
    "ZG2JX_MZ": "Vuelva a comprar  {num} para disfrutar [obtenga {present} por cada  {target} ]",
    "YMZ_MYJY_": "Ha satisfecho [completo S/ {m} menos S/ {n}]",
    "ZGYX_MYJY_": "Recompra S/ {m} para disfrutar [completo S/ {n} menos S/ {o}]",
    "YMZ_MYZ_": "Ha satisfecho el [descuento total de S/ {m} {n}]",
    "ZGYX_MYZ_": "Vuelva a comprar S/ {m} para disfrutar de [descuento total de S/ {n} {o}]",

//
    "QXZJHRQ": "Seleccione una fecha entrega",
    "FuJiaFeiYong": "Recargo",
    "ZhongShangPin_Gong": "Productos",
    "PeiSongShiJian": "Tiempo envío",
    "QXZPSSJ": "Seleccione un tiempo entrega",
    "DingDanJinE": "Monto Pedido",
    "SCFJ_ZD4Z": "Cargue archivos adjuntos, hasta 4 fotos, no más de 3M",
    "KeYongShangPin": "Productos disponibles",
    "ShiYongShuoMing": "Instrucción",
    "YouXiaoQi": "valido",
    "Man": "Lleno",
    "BZZBZCTSFH": "Las observaciones no admiten símbolos especiales.",
    "QingXuanZe": "Por favor seleccione",
    "KaiPiaoXuJia": "Factura necesita agregar",
    "GeDian": "Puntos",
    "KPXJ1GD":'{num} additional points are required for invoicing',
    "PeiSongFangShi": "Método envío",
    "ShangPinZongJia": "Precio total",
    "YouHuiQuan": "Cupón",
    "ZhangKeXan": "unidades disponible",
    "DDJEWMZ": "No se cumple el monto pedido",
    "WDYHQ": "Mi cupon",
    "KYYHQ": "Cupones disponibles",
    "YuanKeYong": "Soles disponible",
    "ChaKanDingDan": "Ver orden",
    "ShangPinHanShui": "Factura",
    "SPWHS": "Producto sin IGV",

    "QueRenDingDan": "Confirmar pedido",
    "XZSHDZ": "Agregar dirección envío",
    "ShangPinQingDan": "Lista productos",
    "WKYYHQ": "No hay cupones",
    "HuChi": "Excluyentes",
    "DaiJinQuan": "Vales",
    "YunFei": "Flete",
    "ShuiFei": "Impuestos",
    "BKYYY": "Motivo no disponible",
    "YHQYGQ": "El cupón expirado",
    "WDYHQSYSJ": "Cupón caducado",
    "ZDSPJEWMZ": "La monto producto especificada no se cumple",
    "BKYYHQ": "Cupón no disponible",


//cart-presale-order

    "QXZPSFS": "Seleccione un método envío",
    "1ZSP_G": "1 producto, total",
    "YSSP_YJ": "producto de preventa, esperados",
    "JiaoHuoRiQi": "Fecha de entrega",
    "GMJLY": "Mensaje al vendedor",


//scan-to-cart

    "ZhengZaiChuLi...": "Procesando ...",
    "FSCSP": "Producto no mall",
    "ZZCLTXM": "Procesando código de barras ...",
    "SPTJCG": "Producto agregado exitosamente",
    "QSTXM": "Escanee el código barras",
    "SFSCDQSP": "¿Eliminar elemento?",
    "BQ_ZBDXGSP": "Lo sentimos, no se encontraron productos relacionados",
    "XuanZeDanWei": "Seleccionar unidad",
    "JRGWC": "Añadir al carrito",
    "QXXZDJRSP": "Seleccione primero los productos que se agregarán",
    "ZhengZaiChuLi": "Procesamiento",
    "JRGWCCG": "Añadir al carrito éxito",
    "ZanWuShangPin": "Sin productos",


//earn-brokerage-share

    "XTYJBNFZSP": "¡El sistema te ha ayudado a copiar el enlace del producto!",
    "NKYHDDYDYJ": "Puede obtener la comisión correspondiente. Las comisiones están disponibles en \"Mi\"",
    "LiChaKan": "Ver adentro",
    "WeiXinHaoYou": "WeChat amigos",
    "ErWeiMa": "Código QR",
    "CASBEWM": "Mantenga presionado para identificar el código QR",
    "FZSB_QCXFZ": "Copia fallida, por favor copie de nuevo!",
    "TWEWM": "Código QR",
    "BCDXC": "Guardar en álbum",
    "CATPBCDXC": "Mantenga presionada la imagen para guardarla en el álbum",
    "FuZhiLianJie": "Copiar enlace",
    "FXZYJ": "Compartir comisión de ganancia",
    "YJZGKZQYJ": "Comisiones máximas esperadas",
    "PYTGNFXDYMCGGMH":"Después de una compra exitosa de UN amigo a través de la página que usted comparte, usted puede recibir la comisión correspondiente.La comisión puede consultarse en \"mi -{path}\"",

//goods-share

    "FXSPGLSKH": "Comparta productos",
    "FXHJSCNZSD": "Después de compartir, se generará su micro-centro comercial móvil exclusivo. Puede establecer el precio de los productos en el centro comercial, completar su información de contacto y atraer consumidores los consumidores vienen a comprar.",
    "WSCDQJG_ND": "Precio actual de Micro Mall: el precio de su pedido ×",
    "DaiSheZhi": "Para ser establecido",
    "PengYouQuan": "Círculo de amigos",
    "GGFXSZ": "Cambiar la configuración para compartir",


//wechat-login

    "QXSRZH": "Ingrese su número cuenta",
    "MMGSCW_6_20W": "Formato de contraseña incorrecta (6-20 caracteres o números)",
    "BDYYZH": "Vincula una cuenta existente",
    "WXKJDL": "Inicio sesión rápido de WeChat",
    "BangDingZhangHao": "Vincular cuenta",
    "YYZH_QDL": "Ya tiene cuenta",
    "ZCXZH": "Regístrese una nueva cuenta",
    "HuanYingNi": "Bienvenido",
    "ZH_SJHM": "Cuenta / Número de móvil",
    "MiMa": "Contraseña",
    "QDLHCZ": "Inicie sesión",


//add-to-cart

    "KCBZ_BNTJG": "Inventario insuficiente para agregar más",


//combined-pay-online

    "ZhiFuChengGong": "¡Pago exitoso!",
    "ZFSB_QCXCS": "¡Pago fallido, por favor intente nuevamente!",


//

    "QXXZGG": "Seleccione la especificación",
    "SXGGX": "Las especificaciones seleccionadas necesitan",
    "GMSLXYQDL_": "La cantidad de compra es menor que el MOQ, ¡compre de nuevo!",
    "GMSLDYXDL_": "La cantidad de compra es mayor que la cantidad de orden límite, ¡compre de nuevo!",
    "ShangPinBianHao": "Producto ID:",
    "QiDing": "MOQ",
    "SXGGDGSLBK": "La cantidad pedida de las especificaciones seleccionadas no puede exceder",
    "KCBZ_BNTJ": "Inventario insuficiente para agregar",
    "QXXZSP": "Seleccione un producto",
    "SLBNW0": "La cantidad no puede ser 0",
    "QXZGG": "Seleccione especs",
    "LiJiYuDing": "Reserve ahora",


//nav

    "ShouYe": "Inicio",
    "ShangPin": "productos",
    "DingDan": "Pedido",
    "WoDe": "La mia",


//pay-online

    "ZhiFuQuXiao": "Cancelación de pago!",


//account-log

    "ShangPinYongJin": "Comisión de productos",
    "YaoQingJiangLi": "Invitación recompensa",
    "TiXian": "Retirarse",
    "TiXianBoHui": "Retiro de retiro",
    "ZhuanWeiYuE": "Girar para equilibrar",
    "Jin7Tian": "Hace 7 días",
    "Jin30Tian": "Hace 30 días",
    "ShouZhiMingXi": "Detalles ingresos y gastos",
    "ZanWuShuJu": "Sin datos",


//client-statistics

    "WoDeKeHu": "Mi cliente",
    "WoDeYaoQing": "Mi invitación",


//distribution-home

    "LeiJiKeHu": "Clientes acumulados",
    "LeiJiDingDan": "Orden acumulativa",
    "YaoQingHaoYou": "Invitar amigos",
    "LeiJiYaoQing": "Invitación acumulativa",
    "LJSY_Y_": "Ingresos acumulados (Soles)",
    "BHDJS": "Liquidación pendiente",
    "J7TSY_Y_": "Ganancias en los últimos 7 días (Soles)",
    "J7TXZKH_R_": "Nuevos clientes en 7 días.",
    "KTXYJ": "Comisión extraíble",
    "XYJYO": "Necesito animar",
    "ChangJianWenTi": "Problema común",
    "Q_ZMYJX_TG": "Q: Cómo \"Promocionar y ganar dinero\"",
    "A_FXDPND_Z_": "A: Comparta el enlace de la página con el ícono de \"ganancia\" en la tienda, atraiga a amigos para que hagan clic y regístrese como amigo (la relación con el cliente está configurada para registrarse enlace) o realizar un pedido (la relación con el cliente está configurada para realizar un enlace de pedido) un cierto método de cálculo cuenta como su ingreso de \"promoción de dinero\".",
    "Q_RHJS_TGZ": "Q: ¿Cómo calcular el beneficio \"Promocionar dinero\"?",
    "A_MGD_Z_TBD": "A: Cada producto con el ícono de \"ganancia\" tiene un cierto porcentaje de comisión. Sin esta marca, significa que el producto no participa en la \"promoción y ganancia\" dinero \". Después de que un amigo paga con éxito a través de su enlace para compartir, la comisión se calculará por separado en función del porcentaje de comisión de cada artículo en el pedido (no la participación en la promoción se convierte en 0), y finalmente se acumula en los ingresos por comisiones del pedido. El envío, los reembolsos y las deducciones completas se deducirán en el cálculo de los ingresos para otras cantidades, prevalecerá el precio final de la transacción.",
    "Q_TGZQ_DSY": "Q: ¿Cuándo se acreditarán las ganancias de \"Promocionar dinero\"?",
    "A_HYTGNDFX": "A: Después de que un amigo paga con éxito a través de su enlace para compartir, puede ver la promoción en el pedido de ventas en el centro de ventas. El estado está pendiente calcular, después de que el cliente confirme que se ha liquidado el recibo de la transacción del pedido, este producto se transferirá automáticamente a su cuenta personal y podrá retirarse en cualquier momento.",
    "Q_LJKH_LJY": "Q: ¿No hay un apodo de avatar en la lista acumulada de clientes e invitaciones acumuladas?",
    "A_WXYQZYGZ": "A: WeChat requiere que el apodo del avatar solo se pueda obtener prestando atención al número del servicio de autenticación. Los clientes que son el número del servicio de autenticación deben prestar atención al número público de la tienda los números de servicio no certificados siguen al número público de \"pedido en la nube\" y hacen clic en cualquier página de detalles del producto en la tienda para obtener el apodo del avatar.",
    "Q_WSMWASSG": "Q: ¿Por qué no comparto los ingresos de la promoción cuando comparto de acuerdo con las reglas anteriores?",
    "A_1_HYKNBW": "A: 1. Es posible que su amigo no haya establecido una relación de cliente con usted (el amigo hizo clic en el enlace de otro vendedor para registrarse o hacer un pedido) 2. Si un amigo abre su enlace para compartir fuera del entorno WeChat (como el navegador predeterminado del teléfono móvil), si el navegador no habilita las cookies,Las relaciones con los clientes no se registrarán, es decir, los pedidos de promoción no se registrarán 3. El pedido de promoción aún no se registra cuando no hay ningún problema arriba, por favor contacte al personal",


//

    "XiaoShouZhongXin": "Centro de ventas",


//generalize-goods

    "SPMC_GG_BH": "Producto / especificación / SKU",
    "YuJiZhuan": "Tu ganancia",


//invitation-home

    "YaoQingKa": "Invitación",
    "YNYQJR_TGY": "Encontraras buenos productos a excelente precio",
    "DJBCDXC": "Haga clic para guardar en el álbum",
    "JYQKFSGHY_": "Invita a tus amigos para tener más ganancias",


//join-home

    "HuanYingJiaRu": "Bienvenido a ",
    "YQNCW": "Te invito a ser",
    "LiJiJiaRu": "Únete ahora",


//order-statistics

    "YuJiYongJin": "Comisión estimada",
    "YongJin": "Comisión",
    "YuJiJiangLi": "Recompensa esperada",
    "JiangLi": "Recompensa",
    "SPTGDD": "Pedido promoción",
    "YQJLDD": "Pedido recompensa de invitación",


//performance-statistics

    "YeJiTongJi": "Estadísticas resultado",
    "LJKH_R_": "Cliente acumulativo",
    "SPYJ_Y_": "Comisión (Soles)",
    "HanDaiJieSuan": "Liquidación pendiente",
    "XGMCJS": "Términos explicados",
    "KeHu": "Cliente",
    "HFXYBDLKHG": "Un comprador o distribuidor que tiene una relación de cliente con un distribuidor.",
    "YaoQing": "Invitar",
    "FXYCGYQDXJ": "Distribuidores subordinados invitados con éxito por los distribuidores",
    "FXYTJKHGMH": "La comisión que el distribuidor puede obtener después de que el distribuidor recomienda al cliente comprar",
    "XJFXYTGSPH": "Recompensa recibida por los superiores después de la promoción",


//posters-promoting

    "NiCheng": "Apodo",
    "HaiBaoTuiGuang": "Promoción de carteles",
    "JHBFSGHY_T": "Enviar carteles a amigos, tiendas gratificantes",


//settlement-home

    "JieSuanZhongXin": "Centro de liquidación",
    "KTXJE": "Monto disponible",
    "TiXianJiLu": "Registros de retiro",


//withdraw-account

    "KHRXMBNWK": "¡El nombre del titular de la cuenta no puede estar vacío!",
    "KHHBNWK": "¡El banco de la cuenta no puede estar vacío!",
    "YHKHBNWK": "¡El número de la tarjeta bancaria no puede estar vacío!",
    "SFZTPBNWK": "¡La imagen de identificación no puede estar vacía!",
    "YHKTPBNWK": "¡La imagen de la tarjeta bancaria no puede estar vacía!",
    "BaoCunChengGong": "¡Guardado éxito!",
    "SCSFZ": "Subir ID",
    "SCYHK": "Subir tarjeta bancaria",
    "BaoCun": "Guardar",
    "TiXianZhangHu": "Cuenta de retiro",
    "TS_QTXZSXX": "Recordatorio: complete la información real, puede retirar efectivo solo después de pasar la revisión",
    "KHRXM": "Titular de cuenta",
    "KaiHuHang": "Banco",
    "YinhangKaHao": "Número de bancaria",
    "QSRZSXM": "Ingrese su nombre real",
    "QSRKHHMC": "Ingrese el nombre banco",
    "QSRYHKH": "Ingrese su número de bancaria",


//withdraw-deposit

    "QXSZTXZH": "Configure cuenta retiro",
    "QuSheZhi": "Ir a la configuración",
    "JEXY10Y_BKT": "La cantidad es inferior a 10 yuanes, no hay retiro de efectivo!",
    "JECGKTXJE": "¡La cantidad excede la cantidad de efectivo disponible!",
    "CGDRKTXSX_": "Superar el límite de retiro el mismo día, ¡el límite de retiro para un solo día es de 20,000 yuanes!",
    "QueDingJiang": "Ok lo haré",
    "ZhuanDaoYuE": "Ir al equilibrio?",

    "_JEDY10YSB": "1. No se permite el retiro de efectivo cuando la cantidad es inferior a 10 yuanes;",
    "_BCTXDZSJ": "2. El tiempo de retiro para este retiro es dentro de los 5 días hábiles posteriores a la iniciación de la solicitud de retiro exitosa.",
    "_GBSRWHSS": "3. Los ingresos son ingresos con impuestos incluidos, ¡diríjase a la agencia tributaria correspondiente para declarar y pagar el impuesto sobre la renta personal por su cuenta!",
    "_ZDYEKYYS": "4. El saldo de transferencia se puede utilizar para comprar en el centro comercial;",

    "TXSQCG_QDD": "Solicitud de retiro exitosa, por favor espere revisión",
    "JEDYKTXJE_": "¡La cantidad es mayor que la cantidad de efectivo disponible y no puede transferirse al saldo!",
    "ZZYECG_QDG": "El saldo de la transferencia es exitoso, por favor verifique en el centro personal",
    "BenCiTiXian": "Esta retirada",
    "ZhuangDaoYuE": "Ir al equilibrio",
    "TiXianDao": "Retirarse a",
    "JEW0BKZZYE": "¡El importe es 0 y no se puede transferir al saldo!",
    "DRTXSX2WY": "Límite de retiro de un día de 20,000 Soles",
    "QuanBuTiXian": "Retirar todo",
    "QueRenTiXian": "Confirmar retiro",


//goods-filter-tab

    "ZuiChangGouMai": "Defecto",
    "MoRenPaiXu": "Defecto",
    "ZongHe": "Defecto",
    "FenLei": "Categoría",
    "XiaoLiangYouXian": "Ventas",
    "XiaoLiang": "Ventas",
    "JiaGe": "Precio",
    "ShaiXuan": "Flitros",
    "ZuiJinGouMai": "Precio",
    "CuXiaoYouXian": "Promoción",
    "QuanBuFenLei": "Todos",
    "ZhiKanCuXiao": "Solo promociones",
    "XuanZeFenLei": "Seleccione categoría",
    "QXZFL": "Seleccione una categoría",


//goods-list-default

    "ZWXGSP": "No hay productos relacionados.",


//goods-brand-list

    "PinPaiHui": "Intercambio de marca",


//goods-classify-filter

    "TuiJianFenLei": "Clasificación recomendada",
    "ShangPinFenLei": "Categorias",
    "GengDuo": "Más",


//goods-detail

    "DLZHBSDQQY": "La cuenta de inicio sesión no es la cuenta del cliente corporativo actual",
    "GXNHQ": "Felicidades",
    "SZWSCJGH_C": "Compartir después de establecer el precio del micro centro comercial",
    "JHDJSHS_": "Tiempo final:",
    "DLHKFX": "Compartir después de iniciar sesión",
    "ZZHQXX_QSH": "Obteniendo información, intente nuevamente más tarde",
    "Zhang": "unidades",
    "Tian": "Día",
    "QXZGGZQPD": "Por favor, seleccione las especificaciones y vaya a la lámpara!",
    "Yuan": "Soles",
    "XS_F_M": "Horas / minutos / segundos",


//integral

    "WoDeJiFen": "Mis puntos",
    "DaBaiLe": "Derrotado",
    "JiFen": "Puntos",
    "DeHuiYuan": "Miembros de",
    "ZhuanJiFen": "Gana puntos",
    "JiFenMingXi": "Detalles puntos",
    "HuanLiPin": "Canjear regalos",
    "CKGDHL": "Ver más regalos",
    "ChaDingDan": "Ver pedido",


//integral-convert

    "DHSLBNCG": "La cantidad de canje no puede exceder",
    "DuiHuanShuLiang": "Cantidad de canje",
    "SuoXuJiFen": "Puntos requeridos",


//integral-detail

    "LiPinXiangQing": "Detalles regalo",
    "WoYaoDuiHuan": "Quiero canjear",
    "ShengYu": "Restante",
    "TuWenXiangQing": "Detalles del product",
    "Jian": "Piezas",
    "YiDuiWan": "Terminado",


//integral-filter

    "FenLeiShaiXuan": "Clasificación",
    "JiFenShaiXuan": "Puntos",


//integral-flow

    "JiFenShouRu": "Puntos de ingreso",
    "JiFenZhiChu": "Gasto de puntos",


//integral-logistics

    "DingDanGenZong": "Seguimiento pedidos",
    "WuLiuGongSi": "Empresa logística",
    "WuLiuDanHao": "Número logística",


//integral-order

    "DingDanLieBiao": "Lista de pedidos",
    "YiFaHuo": "Enviado",
    "JiFenDingDan": "Orden de puntos",
    "ChaKanWuLiu": "Ver logística",


//integral-order-create

    "LPSLBZ_QCX": "No hay suficientes regalos",
    "JiFenBuZu": "Puntos insuficientes",
    "ZhiFuXinXi": "Información pago",
    "JiXuGuangGuang": "Sigue paseando",
    "QTXSHXX": "Por favor complete la información del recibo",
    "DuiHuanChengGong": "Canjeado exito",
    "LPDHQR": "Confirmación de regalos",
    "SCCKJ": "Precio referencia",
    "LiJiZhiFu": "Paga ahora",


//integral-order-detail

    "DingDanXiangQing": "Detalles pedido",
    "DingDanZhuangTai": "Estado pedido",
    "DingDanBianHao": "Pedido",
    "DuiHuanShiJian": "Tiempo redención",
    "ShouHuoXinXi": "Recibiendo información",
    "HuaFeiJiFen": "Gastar puntos",


//integral-rule

    "QDZJF": "Inicia sesión para puntos",
    "XDZJF": "Gane puntos haciendo un pedido",

    "1_MRQD_JL": "1. Registro diario, recompensa {num} punto",
    "2_LXQD3T_EW": "2. Inicie sesión durante 3 días consecutivos con recompensas adicionales {num} punto",
    "3_LXQD7T_EW": "3. Inicie sesión durante 7 días consecutivos con recompensas adicionales {num} punto",

    "DLZJF": "Inicia sesión para ganar puntos",

    "MRDLYSDHSC": "Inicie sesión en {name} mall todos los días y recompense {num} punto",
    "DDWCHKHDYD": "Una vez completado el pedido, puede obtener puntos con el importe del pedido * {num} veces",

//integral-rule-detail

    "GuiZe": "Reglas",


//integral-sign

    "QianDaoYouLi": "Inicia sesión con cortesía",
    "QianDaoGuiZe": "Reglas de check-in",

    "YLXQD": "Registrado consecutivamente",
    "YLXQD1T": "Registrado consecutivamente {num} día",
    "QDCG_NYJLX": "Inicio de sesión correcto, ha registrado durante {num} día consecutivo",
    "QDCG_BCHD1": "Inicie sesión correctamente, obtenga esta vez {num} punto",
    "BCQDHD4JF_": "Regístrese para obtener 4 puntos esta vez, ¡genial!",

//

    "QSRBZ": "Ingrese un comentario",
    "DingDanZengPin": "Pedido regalo",
    "GuiGeBianHao": "SKU: ",
    "GuiGe": "Especs",


//combined-pay

    "CDDWXFK": "No hay pago por este pedido.",
    "YHYEBZ": "Saldo de usuario insuficiente!",
    "ZFJEBNW0": "¡El monto del pago no puede ser 0!",
    "ZFJEBNDYDD": "El monto del pago no puede ser mayor que el monto del pedido",
    "DFKJE": "Monto a pagar",
    "FuKuanFangShi": "Método pago",
    "FuJian": "Adjunto",
    "ZHYFZ": "Cuenta copiada",
    "GHSKZH": "Cambiar cuenta pago",
    "SYXXZFQSCF": "Para el pago fuera de línea, cargue un archivo adjunto de captura de pantalla de pago para la confirmación financiera.",
    "XXZF_BXXZS": "Pago sin conexión, debe elegir una cuenta de pago",
    "DingDanZhiFu": "Pedido de pago",
    "ZFFS_HDFK": "Método de pago: contra reembolso",
    "BCFKJE": "Este pago",
    "YuE": "Saldo",
    "FuZhiZhangHao": " Copiar",
    "WSZXCXZFPZ": "La configuración de pago del applet no está configurada",
    "XCXZFZHJY": "Cuenta de pago del applet deshabilitada",
    "SRZFJE": "Ingrese el monto pago",
    "FuKuanZhangHu": "Cuenta pago",
    "QueRenZhiFu": "Confirmar pago",
    "ShaoHouZhiFu": "Pagar más tarde",


//order

    "FKJLYTJ_DD": "Registro de pago agregado, revisión financiera pendiente",
    "JiXuGuang": "Seguir comprando",
    "BenCiFuKuan": "Este pago",
    "FuKuanChengGong": "Pago exitoso",
    "ZhiFuFangShi": "Método pago",
    "ZhiFuDingDan": "Pedido pago",


//order-batch-pay

    "QXXZSXZFDD": "Por favor seleccione el pedido a pagar",
    "PiLiangFuKuan": "Pago a granel",
    "FuKuan": "Pago",
    "QuFuKuan": "Pagar",


//order-create-result

    "YingFuJinE": "Monto Pedido",
    "XiaDanShiJian": "Tiempo pedido",


//order-deliver

    "SFQRSH": "¿Confirmas recibo?",
    "DDQRSH": "Recibo de confirmación",
    "DFHSP": "Producto ser enviados",
    "ShangPinShuLiang": "Cantidad productos",
    "ChuKuShiJian": "Tiempo entrega",
    "FaHuoShiJian": "Tiempo entrega",
    "WuLiuBeiZhu": "Notas logísticas",
    "QueRenShouHuo": "Confirmar recibo",


//

    "RYFK_QJSYG": "Si se paga, comuníquese administrador",
    "QSRQXYY": "Motivo de cancelación",
    "H_DDJZDGB_QJKF": "Después de que el pedido se cierre automáticamente, pague lo antes posible",
    "TuiHuoQingKuang": "Devoluciones",
    "DingDanZongE": "Pedido total",
    "DingDanBeiZhu": "Notas pedido",
    "FaHuoQingKuang": "Situación de entrega",
    "DingDanFuJian": "Adjuntar pedido",
    "ShenQingTuiHuo": "Aplicar devolución",
    "G1TDSHJL_QRS": "Total {num} registro de recibo, ¿confirmar recibo?",
    "DaiXiaDan": "Pedido para cliente",
    "DingDanHao": "Número pedido",
    "XiaDanFangShi": "Método pedido",
    "TuiHuoDan": "Devolución",
    "ShangPinZongE": "Monto total",
    "YunFei_ZongZhong": "Flete (peso total",
    "SF_SPWS": "Taxes (bienes no gravados)",
    "TePiJia": "Precio especial",
    "FuKuanQingKuang": "Pago",
    "TiaoJiLu": "Registros",
    "ZaiLaiYiDan": "Uno mas",
    "QDSCGDD_": "¿Eliminar este pedido?",
    "YiQueRen": "Confirmado",
    "YiShouHuo": "Recibido",
    "DaiFuJinE": "Monto Por pagar",
    "YiFuJinE": "Monto pagado",
    "ZanWuJiLu": "Sin registro",


//

    "SPMC_DDH": "Producto / número pedido",
    "FuKuanZhuangTai": "Estado pago",
    "FaHuoZhuangTai": "Estado entrega",
    "QiShiShiJian": "Hora de inicio",
    "ZhongZhiShiJian": "Hora final",


//order-list

    "CaoZuoChengGong": "Operación exitosa",
    "ZBKGM": "No disponible para comprar",
    "DQDDSPYXJ": "El producto del pedido actual ha sido eliminado",
    "DQDDBFSPYXJ": "Se han eliminado algunos productos del pedido actual.",
    "JTJSJSP": "Agregar solo listados",
    "DingHuoDan": "Pedido compra",


//order-list

    "DingDanRiZhi": "Registro pedidos",


//order-logistics

    "FuZhiChengGong": "Copia exitosa",
    "FuZhiShiBai": "Copia fallida",
    "FuZhi": "Copia",
    "BoDa": "Marcar",
    "WCWLDHXX": "No hay información de logística",


//order-pay

    "ZFCS_QCXXD": "Se agotó el tiempo de pago, reordenar",
    "YQYYCKZF": "Pagos previos al depósito habilitados",
    "BNDYDFKJE": "No puede ser mayor que la cantidad a pagar",
    "ZFJEBNWK": "El monto del pago no puede estar vacío",
    "QXAPFK_FKH": "Primero organice el pago y cargue la información de pago por captura de pantalla después del pago para la confirmación financiera",
    "DDTJCG_QJS": "Pedido enviado correctamente, pague a tiempo",
    "QXZFKFS": "Por favor seleccione un método de pago",
    "SYYEZFH_HX": "Después de pagar con el saldo, aún debe pagar",


//

    "FuKuanJiLu": "Registro de pago",
    "ZWFKJL": "Sin registro pago",
    "FuKuanXiangQing": "Detalles pago",
    "FuKuanJinE": "Monto pago",
    "ZhiDan": "Fabricación",
    "ShenHe": "Revisar",
    "ZuoFei": "Nulo",
    "ZuoFeiYuanYin": "Razón nula",
    "GLDHD": "Orden relacionada",
    "HeXiaoJinE": "Monto amortizado",
    "HeXiaoZhuangTai": "Estado de baja",
    "DanJuZhuangTai": "Estado pedido",
    "KeHuMingCheng": "Nombre cliente",
    "ZhangDanHao": "Número pedido",
    "ShouKuanZhangHao": "Cuenta de cobro",
    "ShouKuanShiJian": "Tiempo de recogida",
    "FuKuanPingZheng": "Voucher de pago",
    "GeFuJian": "Archivos adjuntos",


//order-statistics

    "DingDanTongJi": "Estadísticas pedidos",
    "DingHuo0Bi": "0 Pedidos",

//order-statistics-detail

    "DDTJMX": "Detalles estadísticos",
    "AGGTJ": "Por Especs",
    "AFLTJ": "Por Categoría",
    "DDJE_Y": "Monto/soles",
    "DHSP_Z": "Productos",
    "DingHuoDan_Bi": "Pedidos",
    "DingHuoShangPin": "Producto",
    "JinE": "Monto",

//refund-list
    "TuiHuo": "Devoluciones",
//refund-apply

    "THDHWBC_QD": "El formulario de devolución no se ha guardado. ¿Estás seguro de que quieres irte?",
    "QSRSQTHJE": "Por favor ingrese la cantidad solicitada para la devolución",
    "QSRTHJE": "Por favor, introduzca el importe de devolución",
    "QSRBZXX": "Por favor ingrese la información del comentario",
    "YingTuiJinE": "Monto devolución",
    "TJTHSQ": "Enviar devolución",
    "QXXZDHQD": "Seleccione primero la lista de pedidos",
    "DingHuoQingDan": "Lista de pedidos",
    "SQTHJE": "Solicitar un monto de devolución",
    "DJXZSP": "Seleccione productos",
    "TuiHuoJinE": "Monto devolución",
//refund-detail
    "THDDXQ": "Detalles del pedido de devolución",
    "YiTuiHuo": "Devuelto",
    "YiTuiKuan": "Reembolsado",
    "THDZT": "Estado del pedido de devolución",
    "TuiHuoDanHao": "Número de nota de devolución",
    "TuiHuoShiJian": "Hora de regreso",
    "TuiHuoCangKu": "Almacén de devolución",
    "THLXR": "Contacto de devolución",
    "TuiHuoQingDan": "Lista de retorno",
    "TuiKuanZongE": "Reembolso total",
    "TuiKuanQingKuang": "Situación de reembolso",
    "DaiTuiJinE": "Cantidad a reembolsar",
    "YiTuiJinE": "Cantidad reembolsada",
//refund-product
    "SPMC_BH_GG": "Busca productos",
    "GZD1TJG": "1 resultado encontrado",
    "JiaRuQingDan": "Agregar",
//refund-result
    "ShenQingChengGong": "Solicitud exitosa",
    "THDTJCG": "Pedido de devolución enviado correctamente",
    "ChaKanXiangQing": "Ver detalles",
//goods-package-floor

    "HDWKS_WDZL": "El evento no ha comenzado, vuelve más tarde",
    "HDYJS_XCZD": "El evento ha terminado, ven temprano la próxima vez",
    "ZWSZBT": "Sin título establecido",
    "ChaKanGengDuo": "Ver más",


//goods-promotion-floor

    "HCDZSJC": "Diferencia horaria causada por el almacenamiento en caché",
    "DLCKCXJ": "Inicie sesión para ver precios promocionales",
    "ZWSZCX": "No hay promociones configuradas",
    "JuKaiShi": "Desde el principio",
    "Song": "Regalar",
    "JuJieShu": "Fin de la distancia",
    "YiJieShu": "Terminó",


//search-floor

    "XiaoXi": "Noticias",
    "SaoMaXiaDan": "Escanear Código",


//home-page-custom

    "WZLCSJ": "Datos de piso desconocidos",


//jump-error

    "QXZYSDHAPP": "Descargue la aplicación de pedidos en la nube",
    "QMTYQYGLD": "Experiencia completa de gestión empresarial.",
    "XZYSDHAPP": "Descargue la aplicación de pedidos en la nube",
    "HQGLDWZTY": "Obtenga la experiencia de gestión completa",
    "JXTYDHD": "Continuar experimentando el lado del pedido",


//notice-detail

    "GongGaoXiangQing": "Detalles del anuncio",
    "GongGaoFuJian": "Adjunto de anuncio",


//shop-error

    "NFWDYMBCZO": "La página que visitaste no existe ~",
    "KeNengYuanYin": "Causa probable",
    "1_ZDZLSRCWD": "1. Ingrese la dirección incorrecta en la barra de direcciones;",
    "2_DJLGQLJ": "2. Hizo clic en el enlace desactualizado.",


//shop-index

    "GuanLiDuan": "Gestión",
    "ZhuCe": "Registrarse",
    "HYNTYYSDH": "Bienvenido a experimentar pedidos en la nube",
    "TYZHSJHDQG": "Los datos de la cuenta de experiencia se actualizan regularmente, no ingrese información importante",
    "TYZHZDNRSJ": "Los datos de contenido en la cuenta de experiencia son ficticios, no ingrese información importante",
    "ZHZCCG": "Registro de cuenta exitoso",
    "DengLuZhangHao": "Cuenta de inicio de sesión",
    "CSMMW": "La contraseña inicial es",
    "GNFYHQL": "Te da un cupón",
    "Man1YuanKeYong": "Más de {currencySymbol}{num}",
    "LQH1TNKY": "Válido solo por {day} días",
    "YiJianLingQu": "Recibir",
    "GXNHD1ZYHQ": "Felicidades por obtener {num} cupón",
    "Gong1Yuan": "Total {currencySymbol} {num}",
    "LiJiShiYong": "Usalo ya!",


//shop-login

    "NHWDL": "No has iniciado sesión",


//shop-notice

    "ShangChengGongGao": "Anuncio de centro comercial",
    "ZanWuGongGao": "Sin anuncio",
    "1GeFuJian": "{num} archivo adjunto",


//deposit-detail

    "KouKuan": "Deducción",
    "ChongZhi_Kuan": "Recarga",
    "KouKuanZuoFei": "Deducción nulo",
    "ChongZhiZuoFei": "Recarga nula",
    "ZhangHuMingXi": "Detalles cuenta",
    "ZhangHuYuE": "Saldo cuenta",
    "LiJiChongZhi": "Recarga ahora",


//deposit-recharge

    "CZJEBNXY1Y": "La monto de recarga no puede ser inferior a 1 soles",
    "QSRZQDSZ": "Ingrese el valor correcto",
    "ZDYJE": "Cantidad personalizada",
    "ZWKTXSCZGN": "La función de recarga en línea aún no se ha activado",
    "ShiFuJinE": "Cantidad pagada",
    "ZhangHuChongZhi": "Recarga cuenta",
    "QXZCZJE": "Seleccione la monto recarga",
    "QSRCZJE": "Ingrese el monto recarga",
    "QLXNDZSYWY": "Póngase en contacto con su vendedor dedicado para recargar",
    "ShouJia": "Precio",
    "YiShouQing": "Agotado",
    "ChongZhiJinE": "Cantidad recarga",
    "QueRenFuKuan": "Confirmar pago",


//deposit-recharge-result

    "QSDDID": "ID pedido faltante",
    "ChongZhiChengGong": "Recarga exitosa",
    "ChongZhiShiBai": "Recarga fallida",
    "CLZ_QSH...": "Procesando, por favor espere ...",
    "ChongZhiFangShi": "Método recarga",
    "ChongZhiShiJian": "Tiempo recarga",
    "JYLSH": "Número de serie de transacción",
    "FanHuiShangCheng": "Vuelta al Mall",


//recharge-online

    "ZFSB_QCS": "Pago fallido, por favor intente nuevamente",
    "ZFYQX": "Pago cancelado",
    "ZFYC_QCS": "Pago anormal, por favor intente nuevamente",


//recharge-online

    "LingQuanZhongXin": "Centro de cupones",
    "WeiShiYong": "Disponible",
    "YiShiYong": "Usado",
    "ZWYHQ": "Sin cupones",


//keep-list

    "YiGouMai": "Comprado",
    "ChangYongQingDan": "Lista Compra",
    "WoDeShouCang": "Favoritos",
    "QuGouWuChe": "Ir al carro",
    "GeShangPin": "Productos",


//login

    "YunShangDingHuo": "Holaplaza.com",
    "QSRZH": "Ingrese su cuenta!",
    "QSRMM": "Ingrese su contraseña!",
    "QSRDLZH": "Ingrese una cuenta de inicio sesión",
    "JiZhuMiMa": "Recordar contraseña",
    "WangJiMiMa": "¿Olvidaste tu contraseña?",
    "DengLu": "Iniciar sesión",
    "DLZHBCZ_QL": "La cuenta de inicio de sesión no existe, póngase en contacto con el administrador para activar",
    "GQYZHSBJY_": "La versión de prueba de la cuenta empresarial está deshabilitada, póngase en contacto Holaplaza.com",
    "GQYZHSYQJS_": "El período de prueba de la cuenta empresarial ha terminado, comuníquese Holaplaza.com",
    "GQYZHYGQL_": "Esta cuenta empresarial ha caducado y requiere renovación para usarla, comuníquese con Holaplaza.com.",
    "LiJiTiYan": "Pruébalo ahora",


//my-collect

    "YiChuChengGong": "Salir éxito",
    "QueHuo": "Sin stock",
    "YCSCJ": "Eliminar favoritos",


//order-message

    "SheZhiChengGong": "Configurar éxito",
    "ZWWDXX": "No hay mensajes no leídos",
    "QuanBuYiDu": "Leer todo",
    "DingDanXiaoXi": "Mensaje",


//

    "YiQiang": "Agarrado",
    "LiJiLingQu": "Reclama ahora",
    "LingQuanHou": "Después de recibir el cupón",
    "TianNeiKeYong": "Disponible en dias",


//

    "QSRSJH": "Ingrese su número de móvil",
    "QSRYZM": "Ingrese el código verificación",
    "QSRXMM": "Ingrese una nueva contraseña",
    "QSRZQSJGS": "Ingrese el formato de móvil correcto",
    "ChongZhiMiMa": "Restablecer contraseña",
    "QSRNDSJHM": "Por favor ingrese su número de celular",
    "QSRDXYZ": "Por favor ingrese la verificación por SMS",
    "HQYZM": "Obtener Código",
    "HKCXHQ": "Se puede recuperar más tarde",
    "QSR6_20WSZHZ": "Ingrese una contraseña de 6-20 dígitos o letra",


//share-setting

    "QSRSPJGBL": "Ingrese la relación precio del producto",
    "SPJGBLBXDY": "La relación del precio debe ser mayor o igual que 100 y menor que 999.99",
    "DPMCZBZCTS": "El nombre de la tienda no admite símbolos especiales",
    "LXRZBZCTSF": "Los contactos no admiten símbolos especiales",
    "LXFSZBZCTS": "El método de contacto no admite símbolos especiales",
    "LXDZZBZCTS": "La dirección de contacto no admite símbolos especiales",
    "DPJJZBZCTS": "El perfil de la tienda no admite símbolos especiales.",
    "QSRDPJJ_ZD": "Ingrese una descripción de la tienda, hasta 50 caracteres.",
    "FenXiangSheZhi": "Configuración de uso compartido",
    "NDWSCSPJG": "Su precio de producto WeChat",
    "NDDHJ_": "El precio de pedido ×",
    "LXXX_KBJ_": "Información de contacto (editable)",
    "DianPuMingCheng": "Nombre tienda",
    "JianJie": "Introduccion",
    "QSRDPMC": "Ingrese el nombre tienda",
    "LianXiRen": "Contacto",
    "QSRLXR": "Ingrese un contacto",
    "LianXiFangShi": "Móvil de contacto",
    "QSRLXFS": "Ingrese la información contacto",
    "LianXiDiZhi": "Direccion contacto",
    "QSRLXDZ": "Ingrese una dirección contacto",


//user

    "WoDeDingDan": "Mi pedido",
    "ZuiJinLiuLan": "Vistos",
    "ShouCangShangPin": " Favoritos",
    "BDYYZH_ZC": "Vincula una cuenta existente | Registra una cuenta nueva",
    "DL_ZC": "Iniciar sesión | Registrarse",
    "BangDingShouJi": "Vincular con su cellular",
    "TS_BDSJHM_": "Consejo: vincule su número de teléfono móvil para que su cuenta sea más segura",
    "ChaKanQuanBu": "Ver todo",
    "ShouHuoDiZhi": "Dirección envío",
    "LianXiWoMen": "Contáctanos",
    "SheZhi": "Configurar",
    "QuQianDao": "Ir a registrarse",
    "QianDao":"Registrarse",
    "JiFenShangCheng": "Mall puntos",
    "TuiGuangShangPin": "Catálogo",
    "QuChaKan": "Ir a",
    "JiFenHuanLi": "Intercambio de puntos",
    "DYSPBQ": "Imprimir etiquetas de productos",


//user-about

    "GYYSDH": "Holaplaza.com",
    "YQHYSMEWM_": "Invite a un amigo a escanear el código QR, descargue e instale directamente",
    "DangQianBanBen": "Versión actual",


//user-address

    "ZWSHDZ": "Sin dirección envío",
    "WoDeDiZhi": "Mi direccion",
    "ZhiNengShiBie": "Reconocimiento inteligente",
    "ZTDZXXKZNS": "Pegar la información de la dirección puede identificar de manera inteligente el nombre, el teléfono y la dirección",
    "MoRen": "Defecto",

//

    "QRSCDZ": "Confirmar eliminar dirección?",
    "SHRXM": "Nombre",
    "SJHMHGDDHZ": "Rellene al menos un número de teléfono móvil o fijo",
    "QSRSHRXM": "Ingrese el nombre del consignatario",
    "ShouJiHaoMa": "Móvil",
    "GuDingDianHua": "Teléfono fijo",
    "QSRGDDH": "Por favor, introduzca un teléfono fijo",
    "SuoZaiDiQu": "Zona",
    "QSRSZDQ": "Por favor ingrese su área",
    "QSRXXDZ": "Ingrese la dirección detallada!",
    "QSRZQDSJHM": "Ingrese el número de movil correcto",
    "QSRZQDGDDH": "Por favor, introduzca el teléfono fijo correcto",
    "XiangXiDiZhi": "Dirección",
    "MoRenDiZhi": "Dirección defecto",
    "SWMRDZ": "Predeterminado",
    "BCBSY": "Guardar y usar",


//user-bing-one

    "QSRSJHM": "Ingrese su número móvil",
    "GYHYZC": "El usuario ya está registrado.",
    "GSJHMYJZCG": "El número de teléfono ya está registrado.",
    "QZJDLJK": "Inicia sesión directamente",
    "QuDengLu": "Ir al inicio sesión",
    "BDHKYTGSJH": "Después de la vinculación, puede iniciar sesión a través de su número de teléfono móvil, lo que le facilita recuperar su contraseña y mejorar la seguridad de la cuenta.",
    "_BDHKYTGSJ": "* Después del enlace, puede iniciar sesión a través de su número de teléfono móvil, para que pueda recuperar su contraseña y mejorar la seguridad de la cuenta.",
    "QSRSJYZM": "Ingrese el código verificación móvil",
    "BDXSJ": "Enlazar teléfono nuevo",
    "DXYZM": "Código verificación de SMS",
    "XiaYiBu": "Paso siguiente",
    "TGCBZ": "Omite este paso",


//user-bing-two

    "DBDSJHMBCZ": "¡El número móvil no existe!",
    "QSRDLMM": "Por favor ingrese su contraseña de inicio sesión!",
    "_GSJHMYBDY": "* El número de teléfono móvil ya está vinculado a una cuenta de pedido en la nube. Verifique la contraseña de inicio de sesión del teléfono móvil y puede vincular la cuenta actual",
    "DQZHMMJTBW": "La contraseña de la cuenta actual se sincronizará con la contraseña de inicio de sesión del teléfono.",
    "DangQianZhangHao": "Cuenta corriente",


//

    "QDYJZ": "Seguro de hacer esto",
    "JSPSCM": "Artículos eliminados?",
    "ShanChuChengGong": "Borrado éxito!",


//user-info

    "SJGSCW": "Error de formato del móvil",
    "YXGSCW": "El correo electrónico está mal formado",
    "WoDeZhangHao": "Mi cuenta",
    "YouXiang": "Email",
    "ShouJi": "Móvil",
    "XingMing": "Nombre",
    "XiuGaiTouXiang": "Modificar avatar",
    "JiBenXinXi": "Información básica",
    "ZhangHaoAnQuan": "Seguridad de cuenta",
    "XiuGaiMiMa": "Cambiar contraseña",
    "DianJiBangDing": "Click Bind",
    "RYDSHTY_QL": "Si se pierde o se desactiva, reemplácelo de inmediato para evitar el robo de cuenta",
    "WBZNDZHAQ_": "Para proteger la seguridad de su cuenta, ate su teléfono",
    "QSRNDXM": "Ingrese su nombre",
    "QSRNDDH": "Ingrese su móvil",
    "QSRNDYX": "Ingrese su Email",


//user-setting

    "QCHCHXCXDL": "Inicie sesión nuevamente después de borrar el caché",
    "QingChuHuanCun": "Borrar caché",
    "QDYQCHCM": "¿Seguro que quieres borrar el caché?",
    "TuiChuDengLu": "Cerrar sesión",
    "QieHuanZhangHao": "Cambiar cuenta",


//user-supplier

    "LianXi": "Contacto ",
    "GongSiDianHua": "Teléfono",
    "DiZhi": "Dirección",


//vouchers-detail

    "DJQMX": "Detalles Cupón",


//vouchers-list

    "BuKeYong": "No disponible",
    "KeYong": "Disponible",
    "ZWDJQ": "Sin cupones",
    "ZongEDu": "Monto total",
    "FaFangShiJian": "Tiempo de liberación",
    "EDYYW": "La cuota se ha agotado",
    "QBSPKY": "Todos los productos disponibles",


//vouchers-select-list

    "WDDJQ": "Mi Cupón",
    "KYDJQ": "Cupón disponibles",
    "DJQKDK": "Los cupones son deducibles",
    "CKKYSP": "Productos disponibles",
    "BKYDJQ": "Cupones no disponibles",
    "BKYYY_ZWFH": "Motivo no disponible: no hay productos elegibles",

    //goods-detail

    "DQSPWSCGGT": "¡El producto actual no ha cargado el mapa de especificaciones y no es compatible con la lámpara!",
    "BoFangShiPin": "Play",
    "Gong1GeGuiGe": "Total {num} Especs",
    "YiXuanGuiGe": "Especs",
    "XuanGuiGe": " Selección",
    "LingQuan": "Cupón",
    // "Jian":"Menos",
    "1ZhongCuXiao": "{num} promoción",
    "1ZhangKeYong": "{num} disponible",
    "ZuiGaoKeSheng": "Hasta para ahorrar",
    "ShangPinTaoCan": "Paquete de productos básicos",
    "Gong1GeTaoCan": "{num} paquete",
    "ShangPinCanShu": "Parámetros del producto",
    "ZhanKai": "Expandir",
    "YiShouCang": "Favorito",
    "ShouCang": "Favorito",
    "KeFu": "Servicio al cliente",
    "XiangQing": "Detalles",
    "TuiJian": "Recomendado",
    "BianHao": "Numero",
    "ShangPinXinXi": "Información del producto",
    "KLYHQ": "Obtener cupón",
    "KuCunBuZu": "Fuera de stock",
    "DuoGuiGe": "Especificaciones múltiples",
    "YiShou": "Vendido",
    "SWBHZ_YS": "Agotado al reponer existencias",
    "CuXiaoShangPin": "Artículos promocionales",


//goods-search

    "NHWSRSSNR": "No has ingresado tu búsqueda",
    "SouSuo": "Buscar",
    "SSY1XGDSP": "Buscar {searchKey} productos relacionados",
    "Yue1GeShangPin": "Acerca de {num} producto",
    "ZuiJinSouSuo": "Buscado recientemente",
    "QingChu": "Claro",
    "ZWSSJL": "Sin historial de búsqueda",


//goods-property

    "ZGJGBNDYZD": "El precio más alto no puede ser más bajo que el precio más bajo.",
    "ShangPinBiaoQian": "Etiqueta del producto",
    "BuGaoYu1": "No más de 1",
    "BuDiYu1": "No inferior a 1",
    "FengGe": "Estilo",


//goods-promotion-list

    "JiJiangKaiShi": "A punto de comenzar",
    "QuanBuCuXiao": "Todas las promociones",


//goods-package-list

    "Gong1JianShangPin": "{num} productos",
    "Sheng": "Provincia",


//goods-package-detail

    "GTCZGWCZDS": "La cantidad de este paquete en el carrito de compras ha alcanzado el límite de compra y no se puede agregar al carrito de compras.",
    "GTCKCBZ_BK": "Este paquete está agotado y no se puede agregar al carrito",
    "JinSheng1Tao": "Solo queda {num} juego",
    "XianGou1Tao": "Limitado a {num} juego",
    "TaoCanXiangQing": "Detalles del paquete",
    "DanMaiJia": "Precio de compra individual",
    "TaoCanJia": "Precio del paquete",
    "HDYJS": "El evento ha terminado.",


//goods-message

    "WDL_QXDL": "No ha iniciado sesión, inicie sesión primero",


//goods-list-label

    "XinPinShangShi": "Nuevo listado",
    "WDLZH_ZWCX": "¡Sin cuenta de inicio de sesión, sin promociones!",
    "YiXiaShangPin": "Los siguientes productos",

//goods-list

    "1ZhongGuiGe": "{num} especificación",
    "YouKuCun": "En stock",

//goods-filter
    "BuGaoYu": "Hasta",
    "BuDiYu": "Desde",
    "CuXiao": "Promoción",
    "ZDYXXZ3G": "Permite la selección de hasta 3",
    "GouMai": "Comprar",
    "Gong1Jian": "Total {num}",
//缺失
    "YiChuShouCangJia": "Eliminar",
    "$": "S/ ",
    "$1": "S/ {num}",
    "_8999_1Qi": "Desde S/ 8999.1",
    "Ge": "Und",
    "BaoZhuangFangShi": "Método embalaje",
    "QRSCSP_": "¿Eliminar producto?",
    "JEWM_TMFRK": "Escanear código QR o barras",
    "0ZSP_G0J": "0 productos, total 0",
    "JiuMiMa": "Contraseña anterior",
    "XMM_6_20WZ": "Nueva contraseña(6-20 dígitos o letras)",
    "QueRenMiMa": "Confirm contraseña",

    "BDHKSYSJHD": "Vincular con su celular, puede iniciar sesión con su móvil, lo que facilita la recuperación de su contraseña y mejora la seguridad.Vincular con su celular, puede iniciar sesión con su móvil, lo que facilita la recuperación de su contraseña y mejora la seguridad.",
    "YanZhengMa": "Código verificación",
    "1MHKCXHQ": "Después 1s",
    "CSJHZ1MQFS": "Este número de movil envió un código verificación hace 1s, intente nuevamente más tarde",
    "GouMaiJiLu": "Mis compras",
    "XinZengDiZhi": "Agregar",
    "LingShouJia": "Precio normal",
    "YouHuiJia": "Precio oferta",
    "ShangPinChuKu": "enviado",
    "DengDaiShouHuo": "recibido",
    "ShouHuoRen": "Consignatario",
    "PaiZhao": "Tomar foto",
    "XiangCe": "Album",

    "TiYanGuan": "Tienda experiencia",
    "JingYingShiJian": "Horas de funcionamiento",
    "ZhanGuanDianHua": "Teléfono de la exposición",
    "ZhanGuanDiZhi": "Dirección del lugar",
    "SJHQZ_QSDZ": "Adquisición de datos, espere e intente nuevamente.",
    "QXXZSF_": "Por favor, seleccione una provincia primero!",
    "QuanBuShengFen": "Todas las provincias",
    "QuanBuChengShi": "Todas las ciudades",
    "YingYeShiJian": "Horario comercial",
    "ChanPinBianHao": "Producto ID",
    "DLXXYGQ_QC": "Inicio sesión caducado, Por favor inicie sesión nuevamente",
    "Man999Jian100": "Compras mas S/{m}, ahorras S/{n}",

    "YiManZu": "Alcanzado",
    "QDYCSP_": "¿Eliminar producto?",
    "DGM10JZ1J": " Compra 10 Unds, llevas 1 gratis ",

    // route-fetch
    "XiaXianTongZhi": "Notificación",
    "NDZHYZQTSB": "Al parecer su usuario está siendo usado en otro dispositivo, si no eres tu por favor cambia tu contraseña",
    "ManJiang":'{num} por {target} pieza completa',
    "ZGLXMJ": 'Comprar {num} pieza más para compartir [{target} piezas se reducen a {currencySymbol}{money_}]',
    "ZGLXMZ":'Compra de {num} pieza más y disfruta de UN descuento del {percent}0% en cada una de las {target} piezas. ',
    "QSRZQNR":'Por favor, introduzca el contenido correcto',
    "NHYDDQKWJQ":'Usted todavía tiene {num} pedidos pendientes por UN total de {currencySymbol}{money} antes de que usted pueda continuar con su pedido',


    //发票助手

    "FaPiaoZhuShou":"Asistente de facturas",
    "WoDeFaPiao":"Mi factura",
    "FaPiaoXiangQing":"Detalles de la factura",
    "KaiPiaoShiJian":"Tiempo de facturación",
    "DaiKaiFaPiao": "Por facturar",
    "DKFPJE":"Importe a facturar",
    "KaiPiaoJinE":"Monto facturación",
    "ZFYDWT_QCSCXZF":"Payment encountered problems, please try to pay again or change the payment method",
    "QingXuanZhe":"Please select a",

    "SXCZ_XDCG":"Credit enough, successful order",
    "SXEDBZ_FKHFH":"Insufficient credit line, delivery after payment",
    "CGJKZQ_FKFH":"After the borrowing period, payment delivery",
    "DDTJCG_XZZCZHYB":"The order was submitted successfully. Now we are only one step away",

    "MianFeiLing":"免费领",
    "M_KMFLQ_HQ":"满{target}元可免费领取，还差{short}元",
    "YHDMFSP":"已获得免费商品",
    "JRMFL":"今日免费领",
    "LingGuangLe":"领光了",
    "KeLingQu":"可领取",
    "YuGuJia":"预估价",

    "GXNHQ_Z_Y_":"Felicidades por obtener {num} {name} de descuento de {price}",
    "LXZSKF":"Customer service",

    "DPYDY_QSHX":"La tienda está cerrada, haga un pedido más tarde.",
    "DaYangShiJian":"Hora de cierre",

    "ChuanHaoChaXun":'Consulta de números de serie',
    'IMEI':'IMEI',

    "FanKuanZhangHu":"Cuenta de reembolso",
    "FanKuanYuE":"Saldo de reembolso",
    "FanKuanZhiFu":"Pago de reembolso",
    "JingDongYiYunJia":"京东易云+",
    "MercadoPago":"MercadoPago",
    "FKYEBZ":"Saldo de reembolso insuficiente",
    "HaiXuZhiFu":"Necesito pagar {price}",
};
export default es_ES;



// WEBPACK FOOTER //
// ./src/locale/es_ES.js